import Modal from './Modal';

/**
 * StillThereModal — Session inactivity warning
 *
 * Shows when user has been inactive for 5 minutes.
 * Displays countdown timer. If no response, auto-logout.
 * Per Sandvik security requirements.
 *
 * @param {Object}   props
 * @param {boolean}  props.isOpen    - Whether the modal is visible
 * @param {number}   props.countdown - Seconds remaining before auto-logout
 * @param {Function} props.onStay    - Called when user clicks "Stay logged in"
 * @param {Function} props.onLogout  - Called when user clicks "Logout"
 */
export default function StillThereModal({ isOpen, countdown, onStay, onLogout }) {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Modal
      isOpen={isOpen}
      closable={false}
      title="Still there?"
      size="sm"
      footer={
        <div className="flex justify-center gap-4">
          <button
            onClick={onLogout}
            className="px-6 py-2.5 border border-n3 rounded text-sm font-medium
                       text-carbon-black hover:bg-n1 transition-colors"
          >
            Logout
          </button>
          <button
            onClick={onStay}
            className="px-6 py-2.5 bg-electric-blue text-white rounded text-sm font-medium
                       hover:bg-blue-dark transition-colors"
          >
            Stay logged in
          </button>
        </div>
      }
    >
      <div className="text-center py-4">
        <p className="text-n6 mb-4">
          You are about to be logged out due to inactivity. Click here to stay logged in.
        </p>
        {countdown > 0 && (
          <p className="text-sm text-n5">
            Auto-logout in: <span className="text-carbon-black">{formatTime(countdown)}</span>
          </p>
        )}
      </div>
    </Modal>
  );
}
